<!-- communication-chat.component.html -->
<ng-container *ngIf="selectedRequestChat; else selectChat">
  <div class="chat-container">

    <!-- HEADER -->
    <div class="chat-header">
      <div class="header-left">
        <button *ngIf="!isFullScreen" nz-button nzType="text" nzShape="circle" (click)="onBack()">
          <i nz-icon nzType="arrow-left"></i>
        </button>
        <span class="chat-title">{{ selectedRequestChat.frontOfficeApplicationId }}</span>
      </div>
      <a (click)="onCancel()" class="open-application-link">Open application</a>
    </div>

    <!-- CHAT BODY -->
    <div class="chat-body" #chatBody>
      <ng-container *ngFor="let group of groupedMessages; let lastGroup = last">

        <!-- DATE HEADER -->
        <nz-divider [nzText]="text" style="padding: 0 16px">
          <ng-template #text>
            <p class="date-header">{{ group.date | date: 'dd.MM.yyyy' }}</p>
          </ng-template>
        </nz-divider>

        <ng-container *ngFor="let chat of group.messages; let i = index; let last = last">

          <nz-divider class="new-message-divider" [nzText]="newMessageText"
                      *ngIf="isShowNewDivider(last, lastGroup, chat)">
            <ng-template #newMessageText>
              <p class="new-message-text">New</p>
            </ng-template>
          </nz-divider>

          <div class="chat-group" [ngClass]="{
            'user': isUserMessage(chat),
            'operator': isOperatorMessage(chat)
          }">

            <!-- AVATAR (только external - слева) -->
            <ng-container *ngIf="isUserMessage(chat)">
              <div class="chat-avatar-initials">
                {{ getInitials(chat) }}
              </div>
            </ng-container>

            <!-- ОБЁРТКА ДЛЯ МЕТЫ + СООБЩЕНИЙ -->
            <div class="message-wrapper">

              <!-- META: external слева, internal справа -->
              <div class="message-meta" [ngClass]="isUserMessage(chat) ? 'align-left' : 'align-right'">
                <span class="sender-name" *ngIf="isUserMessage(chat)">
                  {{ chat.senderFirstName }} {{ chat.senderLastName }}
                </span>
                <span class="message-time">
                  {{ chat.createdAt | date: 'HH:mm' }}
                </span>
              </div>

              <!-- СООБЩЕНИЕ -->
              <div class="chat-message" [ngClass]="chat.isExternalMessage ? 'operator' : 'user'">
                <div class="message-content">
                  <div *ngIf="chat?.content" class="message-text">{{ chat.content }}</div>
                </div>
              </div>

              <!-- ДОКУМЕНТЫ -->
              <ng-container *ngIf="chat.documents && chat.documents.length > 0">
                <div class="chat-message"
                     [ngClass]="chat.isExternalMessage ? 'operator' : 'user'"
                     *ngFor="let document of chat.documents">
                  <div class="message-content">
                    <div class="message-documents">
                      <div class="doc-item"
                           (click)="downloadDocument(document)"
                           [ngClass]="isUserMessage(chat) ? 'align-left' : 'align-right'">
                        <i nz-icon [nzType]="getIconByFileType(document?.contentType)" class="doc-icon"></i>
                        <div class="doc-details">
                          <div class="doc-name">{{ document.fileName }}</div>
                          <div class="doc-meta">{{ document.contentType }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
        </ng-container>

      </ng-container>

      <div #bottomAnchor class="bottom-anchor"></div>
    </div>

    <!-- FOOTER -->
    <div *ngIf="isShowSendMessageBar()" class="chat-footer">
      <nz-badge [nzCount]="attachmentCount" [nzShowZero]="false">
        <button nz-button nzType="text" nzShape="circle" (click)="onAttachClick()" [disabled]="isUploading">
          <i nz-icon [nzType]="isUploading ? 'loading' : 'plus-circle'"></i>
        </button>
      </nz-badge>

      <input
        type="file"
        #chatFileInput
        [accept]="acceptTypes"
        multiple
        (change)="onChatFileChange($event)"
        hidden
      />

      <input
        nz-input
        nzBorderless
        class="chat-input"
        placeholder="Message..."
        [(ngModel)]="message.content"
        (keyup.enter)="sendMessage()"
      />
      <button nz-button nzType="text" nzShape="circle" (click)="sendMessage()" [disabled]="!message.content">
        <i nz-icon nzType="arrow-right"></i>
      </button>
    </div>

    <div *ngIf="selectedRequestChat.disableReason" class="chat-ended-footer">
      <span>{{ selectedRequestChat.disableReason }}</span>
    </div>

  </div>
</ng-container>

<!-- EMPTY STATE -->
<ng-template #selectChat>
  <div class="empty-state">
    <div class="empty-state-box">
      <i nz-icon nzType="message" class="empty-icon"></i><br />
      <span class="empty-text">Select a chat or click "Message" in application to create a new chat.</span>
    </div>
  </div>
</ng-template>